import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ValidationInterceptor } from "./core/interceptors/validation.interceptor";

export const appProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ValidationInterceptor,
    multi: true
  }
]
